import React from 'react';
import { Box, Button, ButtonBase, Divider, Link, Typography } from '@mui/material';
import { DoctorsDrugsItem } from './doctors-drugs-item';
import { Plus, Pill } from '@phosphor-icons/react';
import * as _ from 'lodash';
import { MedicareQuoteQuery } from '@coverright/data-access/medicare';
import { NonOptional } from '../../../index';
import { useDrugSelection, withDrugSelection } from '../lib/with-drug-selection';

function Tab(props: {hideNoDrugsMessage?: boolean}) {
  const {handleDeleteClick, handleAddClick, handleEditClick, drugs} = useDrugSelection();

  return (<>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, p: 1 }}>
      {!drugs.length && <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', pt: '109px'}}>
        {!props.hideNoDrugsMessage && <>
          <Typography variant={'body2'}><b>No drugs added</b></Typography>
          <Typography variant={'body2'} color={'text.secondary'} sx={{maxWidth: 500, textAlign: 'center', mb: 3, mt: .5}}>
            The pricing of the plans may vary based on the Doctors and Drugs you introduce. <Link target={'_blank'} href={'https://coverright.com/medicare-enrollment/best-way-to-know-medications-and-caregivers-covered-on-medicare/'}>Learn more</Link>.
          </Typography>
        </>}

        <Button data-test={'add-your-drugs-button-z1'} className={'drug-btn'} variant={'contained'} size={'large'} onClick={handleAddClick}>
          Add your drugs
        </Button>
      </Box>}

      {!!drugs.length && <Box sx={{border: '1px solid #0000001f', borderRadius: '8px'}}>
        {_.orderBy(drugs, 'name').map((drug, i) => <>
          <DoctorsDrugsItem title={`${drug.name} ${drug.notSupported ? '(not supported)' : ''}`}
                            subtitle={drug.packName}
                            sx={{opacity: drug.notSupported ? .4 : 1}}
                            icon={<Pill size={24} color={'#216069'} />}
                            content={<Box flex={1}>
                              <Typography>{drug.isGeneric ? 'Generic' : drug.genericName || 'Branded'}</Typography>
                              <Typography>{drug.quantity} {_.upperFirst(_.lowerCase(drug.frequency))}</Typography>
                            </Box>}
                            onEditClick={drug.notSupported ? undefined : () => handleEditClick(drug)}
                            onDeleteClick={() => handleDeleteClick(drug)}
                            key={drug.packRxcui} />
          <Divider />
        </>)}

        <ButtonBase data-test={'add-another-drug-button-z1'} sx={{height: 80, pl: '26px', width: 1, justifyContent: 'flex-start', gap: 3}}
                    onClick={handleAddClick}>
          <Plus size={24} color={'#1C434F'} weight={'bold'} />
          <Typography color={'text.secondary'}>Add another drug</Typography>
        </ButtonBase>

      </Box>}
    </Box>
  </>);
}

export const DrugsTab = withDrugSelection(Tab)
